import cn from 'classnames'
import { formatNumbers } from 'core/helpers/format-numbers'
import avatar from 'features/header/assets/images/avatar.png'
import medalGold from './assets/images/medal-gold.png'
import medalSilver from './assets/images/medal-silver.png'
import medalBronze from './assets/images/medal-bronze.png'
import coinIcon from 'features/leaderboard/tabs/assets/images/coin.svg'
import peopleIcon from 'features/leaderboard/tabs/assets/images/people.png'
import c from './assets/sass/item.module.scss'

const MEDALS = { 1: medalGold, 2: medalSilver, 3: medalBronze }
const RANK_CLASS = { 1: c.rank1, 2: c.rank2, 3: c.rank3 }

export const LeaderboardItem = ({ rank, firstName, photoUrl, score, reward, rewardType, caseName, caseImage, type, isMyRow }) => {
    const medal = MEDALS[rank]
    const isTop3 = rank >= 1 && rank <= 3
    const scoreIcon = type === 'COINS' ? coinIcon : peopleIcon
    const rt = rewardType || 'COINS'

    const renderReward = () => {
        if (rt === 'CASE' && caseImage) {
            return (
                <div className={c.reward}>
                    <img className={c.rewardCaseImg} src={caseImage} alt="" />
                </div>
            )
        }
        if (rt === 'CASE') {
            return (
                <div className={c.reward}>
                    <span>🎁</span>
                </div>
            )
        }
        if (rt === 'ENERGY') {
            return (
                <div className={c.reward}>
                    <span>{formatNumbers(parseInt(reward) || 0)}</span>
                    <span className={c.rewardEmoji}>⚡</span>
                </div>
            )
        }
        return (
            <div className={c.reward}>
                <span>{formatNumbers(parseInt(reward) || 0)}</span>
                <img className={c.rewardIcon} src={coinIcon} alt="" />
            </div>
        )
    }

    return (
        <div className={cn(c.component, {
            [c.top3]: isTop3 && !isMyRow,
            [c.myRow]: isMyRow,
            [RANK_CLASS[rank]]: isTop3 && !isMyRow,
        })}>
            {isTop3 && !isMyRow && medal && (
                <img className={c.medal} src={medal} alt="" />
            )}
            {(!isTop3 || isMyRow) && (
                <div className={c.rank}>
                    <span>{rank || '—'}</span>
                </div>
            )}
            <div className={c.player}>
                <img
                    className={c.avatar}
                    src={photoUrl || avatar}
                    alt=""
                    onError={(e) => { e.target.src = avatar }}
                />
                <div className={c.info}>
                    <span className={c.name}>{firstName}</span>
                    <div className={c.score}>
                        <img className={c.scoreIcon} src={scoreIcon} alt="" />
                        <span>{formatNumbers(parseInt(score) || 0)}</span>
                    </div>
                </div>
            </div>
            {renderReward()}
        </div>
    )
}
